import React, { FC, useContext, useEffect } from "react";
import { isPlatform } from "@/domains.ts";
import {
  AnonRoute,
  anonRoutes,
  UserContext,
} from "@/store/context/UserContext.tsx";
import { LoginForm } from "@/pages/auth/LoginForm.tsx";
import { useLocation, useNavigate } from "react-router-dom";
import Api from "@/store/api.ts";
import { useLayoutStore } from "@/store/layout.ts";
import {cn} from "@/utils/shadcn.ts";

let enableAuthCheck = true;

export const LoginModal = () => {
  const { pathname } = useLocation();
  const { authOpen, setAuthOpen } = useLayoutStore();

  const needAuth = (): boolean => {
    let foundAnonRoute = anonRoutes.find((item: AnonRoute) => {
      if (item.platform != "" && !isPlatform(item.platform)) {
        return false;
      }

      return !!item.regexp.test(pathname);
    });

    return !foundAnonRoute;
  };

  const authChecker = () => {
    if (!enableAuthCheck || authOpen) {
      return
    }

    if (needAuth()) {
      Api.getSettings().then((settings) => {
        if (!settings) {
          setAuthOpen(true)
        } else {
          enableAuthCheck = false
        }
      });
    }
  }

  setInterval(authChecker, 8000)

  return (
    <div
      className={cn("fixed top-0 left-0 w-full h-full z-50 flex items-center justify-center bg-black/80 p-4", {
        "hidden" : !authOpen,
      })}
      onClick={() => {
        setAuthOpen(false);
      }}
    >
      <div className="flex w-full max-w-sm flex-col mb-20">
        <LoginForm />
      </div>
    </div>
  );
};
